import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
// import ActionColumn from "../../Components/Document-Management/table/DocumentManagementTableActionColumn";
import PCCLActionColumn from "../../Components/PCCLStorageDocument/table/DocumentManagementTableActionColumn";
import CircularManagementTableActionColumn from "../../Components/CircularManagementSystem/table/DocumentManagementTableActionColumn";
import LatestInstructionGuidelineActionColumn from "../../Components/Latest-Instruction-Guideline/table/DocumentManagementTableActionColumn";
import TypicalDrawingStorageActionColumn from "../../Components/Typical-Drawing-Storage/table/DocumentManagementTableActionColumn";
import moment from "moment";
import { Customer } from "../../types";
import { Chip, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const formatUrl = (url: string) => {
  return url.startsWith("http") ? url : `https://${url}`;
}

export const OverflowTip = ({ children }: any) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef<any>();
  useEffect(() => {
    setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
  }, []);
  return (
    <Tooltip
      componentsProps={{}}
      title={<div className="overflow-tooltip-hover">{children}</div>}
      disableHoverListener={!isOverflowed}
      disableInteractive
    >
      <div ref={textElementRef} className="overflow-tooltip">
        {children}
      </div>
    </Tooltip>
  );
};
const DrawingDocumentManagementTableColumns: GridColDef[] = [
  {
    field: "actions",
    headerName: "",
    type: "actiions",
    renderCell: TypicalDrawingStorageActionColumn,
    hideable: false,
    disableExport: true,
  },
  {
    field: "upload_date",
    headerName: "Uploading Date Time",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => {
      return moment(params.value).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  {
    field: "document_name",
    headerName: "Drawing Name",
    sortable: true,
    minWidth: 160,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "document_type",
    headerName: "Drawing Type",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  // {
  //   field: "division",
  //   headerName: "Division",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   renderCell(params) {
  //     return params.row?.customers?.[0]?.division;
  //   },
  // },
  {
    field: "section",
    headerName: "Division",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueGetter(params) {
      const section_list = new Set<string>();
      params.row.customers?.forEach(({ section }: any) => {
        section_list.add(section);
      });

      return Array.from(section_list).join(", ");
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  // {
  //   field: "customer_name_list",
  //   headerName: "Station",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   // valueFormatter: (params) => {
  //   //   return params.value.join(", ");
  //   // },
  //   // valueGetter: (params) => {
  //   //   return params.value.join(" ,");
  //   // },
  //   renderCell: (params) => {
  //     // const _sortedValues = [...params.value]?.sort((a, b) => a.customerName.localeCompare(b.customerName)) ?? [];
  //     const _sortedValues = params.value?.split(",")?.sort() ?? [];
  //     const _id = params.row.id;
  //     const stations = _sortedValues?.map((station: any, index: number) => (
  //       <Chip
  //         className="users__table__station-chip"
  //         key={"station" + _id + index}
  //         label={station}
  //         size="small"
  //         variant="filled"
  //       />
  //     ));
  //     return <OverflowTip>{stations}</OverflowTip>;
  //   },
  // },
  {
    field: "user_role",
    headerName: "User Role",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "URL",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (row) => {
      if(!row.value) {
        return <span>NA</span>
      }
      return (
        <a href={formatUrl(row.value)} target="_blank" rel="noopener noreferrer">
          Link
        </a>
      );
    },
  },
];

export const InstructionDocumentManagementTableColumns: GridColDef[] = [
  {
    field: "actions",
    headerName: "",
    type: "actiions",
    renderCell: LatestInstructionGuidelineActionColumn,
    hideable: false,
    disableExport: true,
  },
  {
    field: "upload_date",
    headerName: "Uploading Date Time",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => {
      return moment(params.value).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  {
    field: "document_name",
    headerName: "Instruction Name",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "document_type",
    headerName: "Instruction Type",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  // {
  //   field: "division",
  //   headerName: "Division",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   renderCell(params) {
  //     return params.row?.customers?.[0]?.division;
  //   },
  // },
  {
    field: "section",
    headerName: "Division",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueGetter(params) {
      const section_list = new Set<string>();
      params.row.customers?.forEach(({ section }: any) => {
        section_list.add(section);
      });

      return Array.from(section_list).join(", ");
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  // {
  //   field: "customer_name_list",
  //   headerName: "Station",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   // valueFormatter: (params) => {
  //   //   return params.value.join(", ");
  //   // },
  //   // valueGetter: (params) => {
  //   //   return params.value.join(" ,");
  //   // },
  //   renderCell: (params) => {
  //     // const _sortedValues = [...params.value]?.sort((a, b) => a.customerName.localeCompare(b.customerName)) ?? [];
  //     const _sortedValues = params.value?.split(",")?.sort() ?? [];
  //     const _id = params.row.id;
  //     const stations = _sortedValues?.map((station: any, index: number) => (
  //       <Chip
  //         className="users__table__station-chip"
  //         key={"station" + _id + index}
  //         label={station}
  //         size="small"
  //         variant="filled"
  //       />
  //     ));
  //     return <OverflowTip>{stations}</OverflowTip>;
  //   },
  // },
  {
    field: "user_role",
    headerName: "User Role",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "URL",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (row) => {
      if(!row.value) {
        return <span>NA</span>
      }
      return (
        <a href={formatUrl(row.value)} target="_blank">
          Link
        </a>
      );
    },
  },
];

export const PCCLStorageDocumentManagementTableColumns: GridColDef[] = [
  {
    field: "actions",
    headerName: "",
    type: "actiions",
    renderCell: PCCLActionColumn,
    hideable: false,
    disableExport: true,
  },
  {
    field: "upload_date",
    headerName: "Uploading Date Time",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => {
      return moment(params.value).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  {
    field: "document_name",
    headerName: "Document Name",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "document_type",
    headerName: "Document Type",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  // {
  //   field: "division",
  //   headerName: "Division",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   renderCell(params) {
  //     return params.row?.customers?.[0]?.division;
  //   },
  // },
  {
    field: "section",
    headerName: "Division",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueGetter(params) {
      const section_list = new Set<string>();
      params.row.customers?.forEach(({ section }: any) => {
        section_list.add(section);
      });

      return Array.from(section_list).join(", ");
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  // {
  //   field: "customer_name_list",
  //   headerName: "Station",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   // valueFormatter: (params) => {
  //   //   return params.value.join(", ");
  //   // },
  //   // valueGetter: (params) => {
  //   //   return params.value.join(" ,");
  //   // },
  //   renderCell: (params) => {
  //     // const _sortedValues = [...params.value]?.sort((a, b) => a.customerName.localeCompare(b.customerName)) ?? [];
  //     const _sortedValues = params.value?.split(",")?.sort() ?? [];
  //     const _id = params.row.id;
  //     const stations = _sortedValues?.map((station: any, index: number) => (
  //       <Chip
  //         className="users__table__station-chip"
  //         key={"station" + _id + index}
  //         label={station}
  //         size="small"
  //         variant="filled"
  //       />
  //     ));
  //     return <OverflowTip>{stations}</OverflowTip>;
  //   },
  // },
  {
    field: "user_role",
    headerName: "User Role",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "URL",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (row) => {
      if(!row.value) {
        return <span>NA</span>
      }
      return (
        <a href={formatUrl(row.value)} target="_blank" rel="noopener noreferrer">
          Link
        </a>
      );
    },
  },
];

export const CircularDocumentManagementTableColumns: GridColDef[] = [
  {
    field: "actions",
    headerName: "",
    type: "actiions",
    renderCell: CircularManagementTableActionColumn,
    hideable: false,
    disableExport: true,
  },
  {
    field: "upload_date",
    headerName: "Uploading Date Time",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => {
      return moment(params.value).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  {
    field: "document_name",
    headerName: "Document Name",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "document_type",
    headerName: "Document Type",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  // {
  //   field: "customer_name_list",
  //   headerName: "Station",
  //   sortable: true,
  //   minWidth: 110,
  //   hideable: true,
  //   flex: 1,
  //   // valueFormatter: (params) => {
  //   //   return params.value.join(", ");
  //   // },
  //   // valueGetter: (params) => {
  //   //   return params.value.join(" ,");
  //   // },
  //   renderCell: (params) => {
  //     // const _sortedValues = [...params.value]?.sort((a, b) => a.customerName.localeCompare(b.customerName)) ?? [];
  //     const _sortedValues = params.value?.split(",")?.sort() ?? [];
  //     const _id = params.row.id;
  //     const stations = _sortedValues?.map((station: any, index: number) => (
  //       <Chip
  //         className="users__table__station-chip"
  //         key={"station" + _id + index}
  //         label={station}
  //         size="small"
  //         variant="filled"
  //       />
  //     ));
  //     return <OverflowTip>{stations}</OverflowTip>;
  //   },
  // },
  {
    field: "issued_by",
    headerName: "Issued By",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "published_dt",
    headerName: "Issued Date",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell(params) {
      return params.value ? moment(params.value).format("DD-MM-YYYY") : "-";
    },
  },
  {
    field: "user_role",
    headerName: "User Role",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "Brief Description",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
];

export const TABLE_COLUMNS_REPLACEMENT: GridColDef[] = [
  {
    field: "upload_date",
    headerName: "Updated Date Time",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
    valueFormatter: (params) => {
      return moment(params.value).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  {
    field: "document_name",
    headerName: "Document Name",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "document_type",
    headerName: "Document Type",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
  {
    field: "remark",
    headerName: "Remarks",
    sortable: true,
    minWidth: 110,
    hideable: true,
    flex: 1,
  },
];

export default DrawingDocumentManagementTableColumns;
